<template> 
    <v-row align="center" justify="space-around">

        <v-col cols="5" sm="5">
            <v-btn large @click="action('today')" v-on:click="$emit('today')" v-bind:color="Selected === 'today' ? 'buttonSelected' : 'buttonUnselected' ">
                {{ Today }}
            </v-btn>
        </v-col>        
        <v-col cols="5" sm="5">
            <v-btn large @click="action('tomorrow')" v-on:click="$emit('tomorrow')" v-bind:color="Selected === 'tomorrow' ? 'buttonSelected' : 'buttonUnselected' ">
                {{ Tomorrow }}
            </v-btn>
        </v-col>

    </v-row>
</template>

<script>
export default {
    name: 'Buttons',
    data() {
        return {
            Today: '',
            Tomorrow: '',
            Selected: "today"
        }
    },
    methods: {
        getToday() {
            var d = new Date();
            var todayAsNumber = d.getDay(); // 0=sunday, 1=monday....
            var days = ["Sunnuntai", "Maanantai", "Tiistai", "Keskiviikko", "Torstai", "Perjantai", "Lauantai"];
            this.Today = days[todayAsNumber];
        },
        getTomorrow() {
            var d = new Date();
            var todayAsNumber = d.getDay(); 
            var days = ["Sunnuntai", "Maanantai", "Tiistai", "Keskiviikko", "Torstai", "Perjantai", "Lauantai"];
            var tomorrowAsNumber;
            if (todayAsNumber==6) {
                tomorrowAsNumber=0;
            } else {
                tomorrowAsNumber=todayAsNumber+1;
            }
            this.Tomorrow = days[tomorrowAsNumber];
        },
        action(selection) {
            if (selection == "today") {
                this.Selected = "today";
            } else {
                this.Selected = "tomorrow";
            }  
        }
    },
    mounted() {
        this.getToday();
        this.getTomorrow();
    }
}
</script>


<style scoped>

button {
    width: 100%;
    transition: background-color .15s ease-in-out,border-color .15s ease-in-out,box-shadow .15s ease-in-out;
}

</style>